import changeSelectedFolder from '../changeSelectedFolder';
import { logUsage } from 'owa-analytics';
import FilePickerPanelViewState from '../../store/schema/FilePickerPanelViewState';
import popFilePickerBreadcrumbsTill from '../popFilePickerBreadcrumbsTill';
import { SearchBreadcrumbId } from '../../utils/filePickerConstants';

export default function exitSearch(viewState: FilePickerPanelViewState) {
    logUsage('FPExitSearch');
    const { filePickerViewState } = viewState;
    if (filePickerViewState.searchViewState.isInSearchMode) {
        // Remove the "search results" breadcrumb, if one exists.
        if (
            filePickerViewState.breadcrumbs[filePickerViewState.breadcrumbs.length - 1].id ===
            SearchBreadcrumbId
        ) {
            popFilePickerBreadcrumbsTill(
                filePickerViewState.breadcrumbs[filePickerViewState.breadcrumbs.length - 1],
                filePickerViewState
            );
        }
        // Reload the original items of the folder we are in
        changeSelectedFolder(
            filePickerViewState.breadcrumbs[filePickerViewState.breadcrumbs.length - 1]
                .associatedItem,
            viewState
        );
    }
}
